import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const HIDDEN_PATHS = [
  '/',
  '/pricing',
  '/partners',
  '/for-local-businesses',
  '/partner-apply',
  '/create-access',
  '/report-thank-you',
  '/choose-path',
  '/starter-boost',
  '/starter-boost-success',
  '/portal/starter-boost',
  '/repupgrade-in-action',
  '/agencies',
  '/partner-fit',
  '/partner-onboarding',
  '/partner-access',
  '/partner-discovery',
  '/certified-partner',
  '/white-label',
];

export default function FloatingSetupButton() {
  const location = useLocation();

  if (HIDDEN_PATHS.includes(location.pathname) || ['/how-it-works', '/repupgrade-ai', '/playground', '/ai-team'].includes(location.pathname) || location.pathname.startsWith('/ai-team/') || location.pathname.startsWith('/plans/')) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40">
      <Link
        to="/create-access"
        className="bg-dc-orange hover:bg-dc-orange-hover text-white font-bold py-3 px-6 rounded-full shadow-lg hover:shadow-xl transition-all flex items-center gap-2"
      >
        <span>Get Upgraded</span>
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
      </Link>
    </div>
  );
}